import React from 'react';

import InquiryForm from './InquiryForm';
import ComplaintsForm from './ComplaintsForm';
import ContactForm from './ContactForm';
import WreckForm from './WreckForm';
import PartRenovationForm from './PartRenovationForm';
import WreckFormPrivate from './WreckFormPrivate';
import WreckFormInsurer from './WreckFormInsurer';

export default function FormChooser({ form }) {
  const renderForm = formId => {
    switch (formId) {
      case 2:
        return <ComplaintsForm formId={formId} />;
      case 3:
        return <InquiryForm formId={formId} />;
      case 5:
        return <WreckForm formId={formId} />;
      case 8:
        return <PartRenovationForm formId={formId} />;
      case 11:
        return <WreckFormPrivate formId={formId} />;
      case 12:
        return <WreckFormInsurer formId={formId} />;
      default:
        return <ContactForm formId={1} />;
    }
  };

  return <div>{renderForm(form.id)}</div>;
}
